import React from 'react';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import { Shield, Activity, Code, Users, Award, Globe } from 'lucide-react';
import { motion } from 'framer-motion';

const Home = () => {
  const services = [
    {
      icon: Shield,
      title: 'Reliability Assessment',
      description: 'Comprehensive reliability engineering services including Fault Tree Analysis, FMECA, and System Reliability modeling to ensure your systems perform as expected.',
      link: '/services#reliability'
    },
    {
      icon: Activity,
      title: 'Risk Analysis',
      description: 'Advanced risk assessment methodologies (PRA, Bayesian Networks) to identify hazards and mitigate potential failures in complex systems.',
      link: '/services#risk'
    },
    {
      icon: Code,
      title: 'Software Development',
      description: 'Full-stack software development with a focus on reliability, security, and scalability. Expertise in Agile, Cloud-native, and Microservices architectures.',
      link: '/services#software'
    }
  ];

  return (
    <div>
      <Hero />
      
      {/* Services Overview */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-primary sm:text-4xl">Our Expertise</h2>
            <p className="mt-4 text-xl text-slate-600 max-w-2xl mx-auto">
              Delivering engineering excellence through rigorous analysis and innovative software solutions.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us / Trusted By */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary mb-6">Why Choose Eccisoft?</h2>
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <Users className="h-6 w-6" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-primary">World-Class Team</h3>
                    <p className="mt-2 text-slate-600">
                      Our team brings decades of combined experience working with top-tier organizations and government agencies to solve complex engineering challenges.
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <Award className="h-6 w-6" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-primary">Certified Excellence</h3>
                    <p className="mt-2 text-slate-600">
                      We maintain the highest standards of professional practice with certifications in Cloud Architecture, AI, and Project Management.
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <Globe className="h-6 w-6" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-primary">Global Reach</h3>
                    <p className="mt-2 text-slate-600">
                      We have successfully delivered consulting projects and training for clients worldwide, adapting to diverse business environments.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-12 lg:mt-0">
              <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100">
                <h3 className="text-xl font-semibold text-primary mb-6">Trusted Experience With</h3>
                <div className="grid grid-cols-2 gap-6">
                   {/* Using text placeholders for logos for now */}
                   <div className="flex items-center justify-center h-16 bg-white rounded shadow-sm font-bold text-slate-500">NASA</div>
                   <div className="flex items-center justify-center h-16 bg-white rounded shadow-sm font-bold text-slate-500">FAA</div>
                   <div className="flex items-center justify-center h-16 bg-white rounded shadow-sm font-bold text-slate-500">Google</div>
                   <div className="flex items-center justify-center h-16 bg-white rounded shadow-sm font-bold text-slate-500">UCLA</div>
                   <div className="flex items-center justify-center h-16 bg-white rounded shadow-sm font-bold text-slate-500">Boeing</div>
                   <div className="flex items-center justify-center h-16 bg-white rounded shadow-sm font-bold text-slate-500">Lockheed Martin</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
